import React, { Fragment, useEffect } from 'react'
import { SharedStateType } from './types'
import { StepperShell } from '../../components/_WMS/Stepper'
import {
  ErrorStep,
  ScanSku,
  ShowInventoryCheckPositions,
  ValidateInventoryWorkOrder
} from './stepper/screens'
import { WaitingScreen } from './stepper/screens/WaitingScreen'
import { SuccessInventoryCheck } from './stepper/screens/SuccessInventoryCheck'
import { useProductOrigins } from '../../hooks'

const InventoryCheckHandheldPage: React.FC = () => {
  const initialSharedState: SharedStateType = {
    workOrderId: undefined,
    positionCode: undefined,
    error: ''
  }

  const {
    getProductOrigins,
    productOriginsState: { productOrigins }
  } = useProductOrigins()

  useEffect(() => {
    if (productOrigins?.length === 0) {
      getProductOrigins()
    }
  }, [])

  return (
    <Fragment>
      <StepperShell<SharedStateType>
        steps={[
          (props) => <ValidateInventoryWorkOrder {...props} />,
          (props) => <ShowInventoryCheckPositions {...props} />,
          (props) => <WaitingScreen {...props} />,
          (props) => <ScanSku {...props} />,
          (props) => <ErrorStep {...props} />,
          (props) => <SuccessInventoryCheck {...props} />
          // Otros pasos pueden ser agregados aquí de forma similar
        ]}
        initialSharedState={initialSharedState}
      />
    </Fragment>
  )
}

export default InventoryCheckHandheldPage
